<template>
  <div class="widget">
    <div class="title">{{ $t('pages_home_todo_001') }}</div>
    <div class="todo-area">
      <div v-if="todoList.length === 0" class="empty">{{ $t('pages_home_todo_002') }}</div>
      <div v-else class="todo-list">
        <div v-for="(todo, index) in todoList" :key="index" class="todo-item">
          <div class="todo-left">
            <div class="todo-item-title">{{ todo.title }}</div>
            <div class="todo-item-content">{{ todo.content }}</div>
          </div>
          <div class="todo-right">
            <div class="todo-item-time">{{ todo.time }}</div>
            <div @click="handleTodoAction(todo.notifyType)" class="todo-item-action">{{ $t("pages_home_todo_005") }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
export default defineComponent({
  name: 'Todo',
  props: {
    todoList: {
      type: Array,
      required: true
    }
  },
  setup() {
    const router = useRouter()
    const handleTodoAction = (notifyType) => {
      console.log('handleTodoAction', notifyType)
      switch (notifyType) {
        case 2:
          router.push('/user/cert_update')
          break
        case 1:
          router.push('/funds/pay_details')
          break
        default:
          break
      }
    }
    return {
      handleTodoAction
    }
  }
})
</script>

<style lang="less" scoped>
.todo-area {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 20px;
  // round corner
  border-radius: 8px;
  border: solid 1px #E5E9F2;
  .empty {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #A0A7B8;
  }
  .todo-list {
    display: flex;
    flex-direction: column;
    width: 100%;
    .todo-item {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 10px;
      border-bottom: dotted 1px #E5E9F2;
      .todo-left {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: flex-start;
        .todo-item-title {
          color: #514d4d;
          font-size: 12px;
          font-weight: bold;
        }
        .todo-item-content {
          color: #514d4d;
          font-size: 11px;
        }
      }
      .todo-right {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        color: @main-color;
        .todo-item-time {
          color: #333;
          font-size: 11px;
        }
        .todo-item-action {
          font-size: 12px;
          font-weight: bold;
          color: @main-color;
          cursor: pointer;
          padding-left: 10px;
        }
      }
    }
  }
}
</style>
